import request from "@/utils/request";

export function login(params) {
  return request({
    // url: '/vue-admin-template/user/login',
    // url: '/admin/v1/login',
    url: "/api/adminManager/login",
    // url: '/rdhyeng/api/adminManager/login',
    method: "post",
    params,
  });
}

export function getInfo(token) {
  return request({
    url: "/vue-admin-template/user/info",
    method: "get",
    params: { token },
  });
}

export function logout() {
  return request({
    url: "/vue-admin-template/user/logout",
    method: "post",
  });
}
// // 获取用户列表
// export function getUser(params) {
//   return request({
//     url: '/admin/v1/users/list',
//     method: 'post',
//     params
//   })
// }
// 获取用户列表
export function getUser(params) {
  return request({
    url: "/api/usersManager/pageList",
    method: "get",
    params: params,
  });
}

// 获取用户等级
export function getLevels() {
  return request({
    // url: '/admin/v1/users/levels',
    // method: 'post'
    url: "/api/adminManager/user/user_levels",
    method: "get",
  });
}
// 更新单个用户等级
export function updateLevel(params) {
  return request({
    // url: '/admin/v1/users/update_level',
    url: "/api/adminManager/user/update_level",
    method: "post",
    params,
  });
}
// 更新批量用户等级
export function batchUpdateLevel(params) {
  return request({
    url: "/api/adminManager/user/batch_update_levels",
    method: "post",
    data: params,
  });
}
// // 添加用户
// export function addUser(params) {
//   return request({
//     url: '/admin/v1/users/add',
//     method: 'post',
//     params
//   })
// }
// 添加用户
export function addUser(data) {
  return request({
    url: "/api/usersManager/admin/insert",
    method: "post",
    data,
  });
}

// 删除用户
export function deleteUser(params) {
  return request({
    url: "/admin/v1/users/delete",
    method: "post",
    params,
  });
}

// 后台编辑用户
export function updateUser(data) {
  return request({
    url: "/api/usersManager/admin/update",
    method: "put",
    data,
  });
}

// 获取阅读权限分组列表
export function getReadingGroup(params) {
  return request({
    url: "/api/readingGroup/pageList",
    method: "get",
    params: params,
  });
}
// 修改阅读权限分组
export function updateReadingGroup(data) {
  return request({
    url: "/api/readingGroup/update",
    method: "put",
    data,
  });
}
// 修改阅读权限分组状态
export function updateReadingGroupStatus(data) {
  return request({
    url: "/api/readingGroup/updateStatus",
    method: "put",
    data,
  });
}

// 添加用户
export function addReadingGroup(data) {
  return request({
    // contentType: 'json',
    url: "/api/readingGroup/add",
    method: "post",
    data,
  });
}
